export default __webpack_public_path__ + "static/media/SKS_Chief.12a95b87.svg";